import { datalabHttp } from '@dbl/services/common';
import { AxiosRequestConfig } from 'axios';

// 获取首页模板中心、最近访问、分享报表数据
export enum TableDataTab {
  Template = 'template',
  Recent = 'recent',
  Share = 'share'
}
// 每个页签下的二级页签
export enum SubTagType {
  All = 'template',
  Game = 'game_template',
  Public = 'public_template'
}
// 二级页签下卡片与表格
export enum SubTableAndCard {
  Table = 'table',
  Card = 'card'
}

export interface RecentlyOrShareTableData {
  name: string; // 名称
  name_cn: string; // 中文名称
  id: string; // 报表 或者图表 或者号码包ID
  category: string; // 打点的pageId
  date: string; // 最近访问时间 或 分享时间 格式为 YYYY-MM-DD HH:MM:SS
  owner: string; //
  read?: boolean; // 报表或图表的只读权限
  edit?: boolean; // 报表或图表的编辑权限
}
interface ResponseOfRecentlyOrShare {
  count: number; // 数据总量
  list: RecentlyOrShareTableData[]; //
}

export function getRecentlyOrShare(params: {game_code: string; tab: TableDataTab;}): Promise<ResponseOfRecentlyOrShare> {
  const options: AxiosRequestConfig = {
    url: '/api/v1/datalab/home',
    method: 'post',
    data: params,
  };
  return datalabHttp(options) as Promise<ResponseOfRecentlyOrShare>;
}



